import React, { Component } from 'react';
import "../styles/customerHero.css";
import { NavLink } from "react-router-dom";

export default class CustomerHero extends Component {
  constructor(props) {
      super(props);
      this.state = {
          componentReady: ''
      };
  }

  componentDidMount = () => {
    setTimeout(function() {
      this.setState(
				{
					componentReady: 'ready'
				}
		);

    }.bind(this), 10);
  }
  render() {
    return (
      <div className={this.state.componentReady}>
        <NavLink className="back-button"  exact to="/work" >
          <img alt="" className="full-width" src="images/back.png" />
        </NavLink>
      	<div className="customer-hero">
  		    <div id="hero-parallax" className="customer-hero-content">
			       <div className="medium-max-width-container">
			          <h4 className="customer-hero-subtitle uppercase full-width">{this.props.company}</h4>
			          <h1 className="customer-hero-title full-width">{this.props.title}</h1>
			       </div>
		      </div>
		      <div className="customer-hero-tint" style={{backgroundColor:this.props.overlayColor}}></div>
		      <div className="customer-hero-video" style={{opacity:0}}></div>
		      <div className="customer-hero-background" style={{backgroundImage: "url(" + this.props.backgroundImage + ")"}}></div>
		    </div>
	  </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/customerHero.js